<template>
    <div>
        <breadcrumb></breadcrumb>
        <div class="h-piece">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                <el-form-item label="客户名称">
                    <el-input v-model="formInline.user" placeholder="客户名称"></el-input>
                </el-form-item>
                <el-form-item label="活动区域">
                    <el-select v-model="formInline.region" placeholder="活动区域" style="width:1.5rem">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="拜访时间">
                    <el-col :span="11">
                    <el-date-picker type="datetime" placeholder="选择时间" v-model="formInline.date1" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line h-txtCenter" :span="2">至</el-col>
                    <el-col :span="11">
                    <el-time-picker type="datetime" placeholder="选择时间" v-model="formInline.date2" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker type="date" placeholder="选择时间" v-model="formInline.date3" style="width: 1.5rem;"></el-date-picker>
                </el-form-item>
                <el-form-item class="h-formBtnOut">
                    <el-button class="h-btn h-formBtn">检索</el-button>
                </el-form-item>
                </el-form>
            </div>
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="formLabelAlign" label-position="right" :rules="rules" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
                        <el-form-item label="项目名称" class="h-elformWrap-2" prop="name">
                            <el-input v-model="formLabelAlign.name"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人" class="h-elformWrap-2">
                            <el-input v-model="formLabelAlign.contact"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式" class="h-elformWrap-2">
                            <el-input v-model="formLabelAlign.contactInfo"></el-input>
                        </el-form-item>
                        <el-form-item label="需求类型" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type" placeholder="需求类型">
                            <el-option label="类型一" value="type1"></el-option>
                            <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="答复日期" class="h-elformWrap-2">
                            <el-date-picker type="date" placeholder="选择时间" v-model="formLabelAlign.date3"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="联系人" class="h-elformWrap-1">
                            <el-input v-model="formLabelAlign.contact"></el-input>
                        </el-form-item>
                        <el-form-item label="需求说明" class="h-elformWrap-1">
                            <el-input type="textarea" v-model="formLabelAlign.explain"></el-input>
                        </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <h1 style="font-size: 0.24rem;color: #0056a4;margin-bottom: 20px;font-weight: normal;margin-top: 30px;">表单中按钮</h1>
		<div>
			 <el-button class="h-btn h-formBtn">深蓝 </el-button>
			 <el-button class="h-btn h-formBtn h-bgblueQ">浅蓝 </el-button>
			 <el-button class="h-btn h-formBtn h-bggreen">绿色 </el-button>
			 <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus">新增内销预测</el-button>
		</div>
		<h1 style="font-size: 0.24rem;color: #0056a4;margin-bottom: 20px;font-weight: normal;margin-top: 30px;">页面底部按钮</h1>
		<div>
			 <el-button class="h-btn h-bBtn h-bggreen">绿色 </el-button>
			 <el-button class="h-btn h-bBtn h-bgwhite">白色 </el-button>
			 <el-button class="h-btn h-bBtn">蓝色蓝色 </el-button>
			 <el-button class="h-btn h-bBtn h-bgblue2">蓝色蓝色 </el-button>
		</div>
    </div>
</template>
<script>
export default {
    data(){
      return{
       formInline: {
            user: '',
            region: '',
            date1: '',
            date2: '',
            date3: '',
        },
        formLabelAlign: {
            name: '',
            contact:'',
            contactInfo:'',
            type: '',
            date3: '',
            explain:''
        },
        rules: {
            name: [
            { required: true, message: '请输入项目名称', trigger: 'blur' },
            ],
        }
      }
    },
    component(){
        breadcrumb
    }
}
</script>
<style>

</style>